<template>
  <aside ref="aside" class="aside-box">
    <!--导航菜单-->
    <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" :class="{'collapse':isCollapse}"
      @open="handleOpen" @close="handleClose" @select="handleSelect" :unique-opened="false" :router="false"
      :collapse="isCollapse" v-loading="loading" :default-openeds="defaultOpened" v-if="!specialChannel">
      <template v-for="(item,index) in menuList">
        <template v-if="!item.hidden">
          <el-submenu :index="`${item.menuId}`" v-if="item.children && item.children.length>0" :key="index"
            popper-class="pop-submenu">
            <template slot="title">
              <i :class="item.icon" class="iconfont"></i>
              <span slot="title">{{item.menuName}}</span>
            </template>
            <template v-for="(child,index) in item.children">
              <el-tooltip class="item" effect="dark" placement="top" :key="`${child.url}_${index}`"
                v-if="child.menuName.length>100">
                <el-menu-item :index="child.url" :key="`${child.url}_${index}`" v-if="!child.hidden">
                  {{child.menuName || child.name}}
                </el-menu-item>
                <div slot="content">{{child.menuName}}</div>
              </el-tooltip>
              <el-menu-item :index="child.url" :key="`${child.url}_${index}`" v-else>
                {{child.menuName || child.name}}
              </el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else :key="index" :index="item.url">
            <template>
              <div class="single-menu">
                <i :class="item.icon" class="iconfont"></i>
                <span slot="title">{{item.menuName}}</span>
              </div>
            </template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
    <!-- <i class="el-icon" :class="{'el-icon-s-unfold':isCollapse,'el-icon-s-fold':!isCollapse}" @click="toggleClick"></i> -->
    <div v-for="item in menuList" :key="item.menuId" v-else class="menu-template">
      <div class="channel-title" v-show="item.menuName">{{item.menuName}}</div>
      <el-menu :default-active="defaultActive" class="el-menu-channel" :class="{'collapse':isCollapse}"
        @open="handleOpen" @close="handleClose" @select="handleSelect" :unique-opened="false" :router="false"
        :collapse="isCollapse" v-loading="loading" :default-openeds="defaultOpened">
        <template v-for="(item,index) in item.children">
          <template v-if="!item.hidden">
            <el-submenu :index="`${item.menuId}`" v-if="item.children && item.children.length>0" :key="index"
              popper-class="pop-submenu">
              <template slot="title">
                <i :class="item.icon" class="iconfont"></i>
                <span slot="title">{{item.menuName}}</span>
              </template>
              <template v-for="(child,index) in item.children">
                <el-tooltip class="item" effect="dark" placement="top" :key="`${child.url}_${index}`"
                  v-if="child.menuName.length>100">
                  <el-menu-item :index="child.url" :key="`${child.url}_${index}`" v-if="!child.hidden">
                    {{child.menuName || child.name}}
                  </el-menu-item>
                  <div slot="content">{{child.menuName}}</div>
                </el-tooltip>
                <el-menu-item :index="child.url" :key="`${child.url}_${index}`" v-else>
                  {{child.menuName || child.name}}
                </el-menu-item>
              </template>
            </el-submenu>
            <el-menu-item v-else :key="index" :index="item.url">
              <template>
                <i :class="item.icon" class="iconfont"></i>
                <span slot="title">{{item.menuName}}</span>
              </template>
            </el-menu-item>
          </template>
        </template>
      </el-menu>
    </div>
  </aside>
</template>

<script>
import cookie from '@/utils/cookie'
import { openNavUrl, isSpecialChannel, canUseSalesLabel, SALES_LABEL_DENY_TIP } from '@/utils'
import { canUseLightCustomerService } from '@/utils/version'
import routers from '@/utils/router'
import cockpit from '@/router/cockpit'
import { mapGetters } from 'vuex'
export default {
  name: 'yblMenu',
  props: {
    isCollapse: {
      type: Boolean,
      default: () => false
    },
    roleId: { // 人管（8801）
      type: String | Number,
      default: () => ''
    }
  },
  data () {
    return {
      // isCollapse: false,
      menuList: [],
      url: '',
      array: [],
      cockpitArray: [],
      loading: true,
      originMenus: [],
      newQuotePids: [],
      // AI轻客服菜单的 permissionCode，非「创收版 V6 及以上且非入门版」商户按此编码隐藏该菜单
      aiLightCustomerPermissionCode: 10007,
      latestPids: [10000, 22427, 25693, 25692, 25687, 25592, 22542, 22548, 20621, 25608, 22608, 20088, 22419, 25691, 25824, 25246, 20018, 25805, 20200, 25742, 25665, 25020, 25778, 25621, 22665, 25401, 25713, 25348, 25347, 25598, 25712, 25341, 25340, 25339, 25345, 25708, 25167, 25648, 20011, 25394, 20417, 25518, 20025, 20038, 20049, 23031, 22180, 21901, 20009, 24298, 25011, 20056, 25819, 25159, 25158, 24454, 25357, 23543, 25044, 25324, 23863, 23848, 24778, 25160, 20181, 25542, 23283, 25697, 25056, 22367, 25311, 24791, 22719, 25456, 20384, 25291, 25506, 25726, 24014, 20029, 20092, 24973, 24348, 21826, 24514, 24249, 25813, 25654, 25759, 24970, 20046, 20049, 24842, 25847]
    }
  },
  created () {
    this.array = routers.map(item => item.path)
    this.array.push('/role/home')
    this.array.push('/organization/home')
    this.cockpitArray = cockpit.map(item => item.path)
    if (!this.userInfo) {
      this.loginCustomer().then(() => {
        this.initSideBarMenu()
      })
    } else {
      this.initSideBarMenu()
    }
    const item = this.activedData
    const { url } = this.$route.query
    this.url = item.url || decodeURIComponent(url) || ''
  },
  mounted () {
    //  :max-height="maxHeight"
    // let height = document.documentElement.clientHeight
    this.$nextTick(() => {
      // this.maxHeight = height - 100
      // console.log(height)
      // let aside = this.$refs['aside']
      // aside && (aside.style.height = (height - 90) + 'px')
      // console.dir(aside)

      /* if (process.env.NODE_ENV === 'development' || !this.userInfo) {
        this.loginCustomer()
      } */
    })
  },
  computed: {
    ...mapGetters([
      'CUSTOMER_LOGINCUSTOMER',
      'activedData',
      'commonData'
    ]),
    userInfo () {
      return this.CUSTOMER_LOGINCUSTOMER.data
    },
    defaultActive () {
      return this.$route.path.replace('/j/', '/').replace('/sho/', '/').replace('/q/', '/').replace('/k/', '/x5/').replace('/ck/', '/x5/')
    },
    isMicroApp () {
      // return true // this.$route.path.includes('/j/')
      return process.env.IS_MICRO_APP
    },
    specialChannel () {
      if (!this.userInfo) {
        return false
      }
      const { IsChannelCustomer } = this.userInfo
      const isSpecial = IsChannelCustomer// Pratner && [3, 4, 22].includes(+Pratner.systemVersion) && [12, 13, 14].includes(+RoleGroupIds)
      return isSpecialChannel() || isSpecial
    },
    Pratner () {
      return (this.userInfo && this.userInfo.Pratner) || ''
    },
    isFengYuan () {
      // return process.env.NODE_ENV === 'development' || `${this.Pratner.partnerid}` === '20054'
      return false
    },
    token () {
      return this.commonData.token || cookie.getCookie('InsBackUserToken_V3') || ''
    },
    crmUinfo () {
      return cookie.getCookie('uinfo') || ''
    },
    v5Flag () {
      return this.Pratner && this.Pratner.partnerEx && this.Pratner.partnerEx.v5Flag
    },
    // AI轻客服菜单：创收版 V6 及以上且非入门版商户才显示；是否有权限由后端菜单下发控制
    canShowAiLightCustomerMenu () {
      return canUseLightCustomerService(this.Pratner)
    },
    defaultOpened () {
      // 定义最大数量常量
      const MAX_NUM = 30

      // 封装计算子菜单数量的函数
      const getTotalChildrenCount = (menuList) => {
        let count = 0
        if (menuList && menuList.length) {
          menuList.forEach(item => {
            count += 1
            if (item.children && item.children.length) {
              count += item.children.length
            }
          })
        }
        return count
      }

      // 封装获取有子菜单的菜单项 ID 的函数
      const getMenuIdsWithChildren = (menuList) => {
        return menuList && menuList
          .filter(item => item.children && item.children.length > 0)
          .map(item => item.menuId + '')
      }

      if (this.specialChannel) {
        if (this.menuList && this.menuList.length > MAX_NUM) {
          return []
        }
        return getMenuIdsWithChildren(this.menuList)
      } else {
        const childrenNum = getTotalChildrenCount(this.menuList)
        if (childrenNum > MAX_NUM) {
          return []
        }
        return getMenuIdsWithChildren(this.menuList)
      }
    }
  },
  methods: {
    handleOpen () {
      console.log('url=', this.$route)
      console.log('handleOpen')
    },
    handleClose () {
      console.log('handleClose')
    },
    handleSelect: function (url, b) {
      // console.log(url, b, this.array)
      if (url) {
        let { host, protocol } = window.location
        let target = 'self'
        const item = this.originMenus.find(m => m.url === url)
        // 菜单 URL 可能带 query(如批单录入 /insurance/add?insuranceLabel=1),按剥掉 query 的 path
        // 判断是否站内路由;否则带 query 的站内 URL 会落入下方 microApp 分支,拼出 //path 双斜杠导致路由匹配不上
        const urlPath = url.split('?')[0]
        if (!this.array.includes(urlPath) && url !== '/home/index') {
          if (url.indexOf('new-quote.youbaolian') !== -1 || url.indexOf('wwx.youbaolian') !== -1 || url.includes('/LitePaperOffer/newindex#A')) {
            target = 'blank'
          }
          const prefix = host.split('.')[0]
          let pre2 = process.env.NODE_ENV === 'production' ? '' : `${prefix}.`
          if (url.indexOf('new-quote.youbaolian.top/index') !== -1) {
            url = `${protocol}//${pre2}cxv3.youbaolian.top/LitePaperOffer/newindex`
          } else if (url.indexOf('new-quote.youbaolian.top/insure/list') !== -1) {
            // let pid = this.userInfo && this.userInfo.PartnerId
            url = 'new-quote.youbaolian.top'
            // if (this.latestPids.indexOf(pid) !== -1) {
            //   url = 'new-quote.youbaolian.top'
            // } else if (this.newQuotePids.indexOf(pid) !== -1) {
            //   url = 'quote.youbaolian.top'
            // }
            url = protocol + ((prefix === 'pre1' || prefix === 'pre2' || prefix === 'dev') ? '//' + prefix + '.' : '//') + url + '/insure/list'
          } else if (url.indexOf('wwx.youbaolian.top') !== -1) {
            url = (prefix === 'pre1' || prefix === 'pre2' || prefix === 'dev') ? 'wwx.youbaolian.top/customer' : 'new-quote.youbaolian.top/customer'
            url = protocol + ((prefix === 'pre1' || prefix === 'pre2' || prefix === 'dev') ? '//' + prefix + '.' : '//') + url + `?partnerId=${this.userInfo.PartnerId}&token=${this.token}`
            console.log('wwx:', url)
          } else if (url.indexOf('sxcore') !== -1 && url.indexOf('/#') !== -1) {
            url = url.replace(/sxcore(-test)?/, `${pre2}sxcore`)
          } else if (item && [0, 6].includes(+item.systemCode) && !item.url.includes('bi')) {
            if (!url.includes('/x5')) {
              url = !this.crmUinfo
                ? `${protocol}//${pre2}crm.youbaolian.top/complete?saastoken=${this.token}&jump=${url.replace(/^\//, '')}`
                : `${protocol}//${pre2}crm.youbaolian.top/${url.replace(/^\//, '')}`
            }
          }
          console.log('url=', url, target, this.isMicroApp)
          this.url = ''
          if (this.isMicroApp) { // 是否包含子集操作
            const strArray = url.split('//')
            const arr = (strArray.length > 1 && strArray[1].split('/')) || []
            if (url.includes('new-quote.youbaolian')) {
              arr.splice(0, 1, 'q')
              /* } else if (url.includes('cxv3.youbaolian')) {
                arr.splice(0, 1, 'j') */
            } else if (url.includes('sxcore.youbaolian')) {
              arr.splice(0, 1, 'sho')
            }
            const _url = (arr && arr.length > 0 && arr.join('/')) || `${url}`
            if (_url.includes('j/')) { // 特殊处理java/net页面
              openNavUrl(url, '', host, target)
              return
            } else if (url.includes('x5/')) {
              const replaceKey = (!this.specialChannel && url.includes('/clientele')) ? 'ck' : 'k'
              url = url.replace('x5/', `${replaceKey}/`)
              this.$store.dispatch('setActive', { ...item }).then(() => {
                this.$router.push({ path: url })
              })

              return
            }
            this.$router.push({ path: `/${_url}` })
            return
          } else if (url.includes('bi.')) {
            this.url = url
            // const menu = this.originMenus.find(item => item.url === url)
            this.$store.dispatch('setActive', {url: url}).then(() => {
              this.$router.push({path: '/bi/page', query: {id: new Date().getTime()}})
            })
            return
          } else if (url.includes('x5/')) {
            const replaceKey = (!this.specialChannel && url.includes('/clientele')) ? 'ck' : 'k'
            url = url.replace('x5/', `${replaceKey}/`)
            this.$store.dispatch('setActive', { ...item }).then(() => {
              this.$router.push({ path: url })
            })

            return
          }
          openNavUrl(url, '', host, target)
        } else if (url.includes('/policy/marketing')) {
          if (![1, 4, 5, 6].includes(+this.v5Flag)) {
            this.$alert('如需使用此功能，请联系您的客户经理，将账号升级至 V5 标准版或更高版本！')
            return
          }
          this.$router.push({ path: url })
        } else if (url === '/personnel/label' && !canUseSalesLabel()) {
          // 标签管理仅创收版 V6 及以上的专业版/旗舰版可用（WZPE-46980）
          this.$alert(SALES_LABEL_DENY_TIP, '提示', { type: 'warning' })
        } else {
          // openNavUrl(url, '', host, 'self', false)
          if (url === '/home/index') {
            url = '/home'
          }
          if (cockpit && cockpit.length && this.cockpitArray.includes(url)) {
            // 处理驾驶舱的跳转
            openNavUrl(url, '', host, 'blank', false)
          } else if (location.pathname !== url) {
            this.$router.push({ path: url })
          }
        }
      }
    },
    toggleClick () {
      this.isCollapse = !this.isCollapse
    },
    loginCustomer () {
      return this.$store.dispatch('customerLoginCustomer').then(({ data }) => {
        return data
      })
    },
    getAuthorization () {
      return this.$store.dispatch('customerGetAuthorization').then(data => {
        console.log(data)
        let menus = data.datas.filter(item => +item.ParentCode === 17)
        menus = menus.map(item => ({
          ...item,
          children: data.datas.filter(child => child.ParentCode === item.PermissionCode)
        }))
        console.log(menus)
        return menus
      })
    },
    getMenu () {
      const roleId = this.specialChannel ? '0' : (this.roleId || '-1')
      return this.$store.dispatch('customerGetMenu', { id: roleId }).then(data => {
        return data
      })
    },
    initSideBarMenu () {
      this.getMenu().then(({ datas }) => {
        const menus = (datas || []).filter(item => item.parentId !== null && item.menuName)
        this.originMenus = menus
        let tempMenu = this.arrayToTree(menus)
        console.log('🚀 ~ file: SideBar.vue:260 ~ this.getMenu ~ tempMenu:', tempMenu, this.isFengYuan)
        if (this.specialChannel) {
          /* const urls = ['/dataManage', '/setting/index', '/human', '/finance/index', '/feiche/home', '/home', '/product/index', '/ultimate/embranchment', '/LitePaperOffer/newindex#A']
          tempMenu = tempMenu.map(item => {
            if (item.url && !urls.includes(item.url) && !item.url.includes('#/myhome')) {
              const children = [{...item}]
              item.menuName = ''
              item.children = children
            }
            return item
          }) */
        }
        if (this.isFengYuan) {
          tempMenu = tempMenu.filter(item => ![10, 11].includes(+item.permissionCode))
        }
        if (!this.canShowAiLightCustomerMenu) {
          tempMenu = this.filterMenuByPermissionCode(tempMenu, this.aiLightCustomerPermissionCode)
        }
        this.menuList = tempMenu
        this.loading = false
      })
    },
    arrayToTree (data) {
      const result = []
      const itemMap = {}
      for (const item of data) {
        const id = item['menuId']
        const pid = item['parentId']

        if (!itemMap[id]) {
          itemMap[id] = {
            children: []
          }
        }

        itemMap[id] = {
          ...item,
          children: itemMap[id]['children']
        }

        const treeItem = itemMap[id]
        if (+pid === 0) {
          result.push(treeItem)
        } else {
          if (!itemMap[pid]) {
            itemMap[pid] = {
              children: []
            }
          }
          itemMap[pid].children.push(treeItem)
        }
      }
      return result
    },
    filterMenuByPermissionCode (menus, code) {
      if (code === '' || code === null || code === undefined) {
        return menus
      }
      return menus.filter(item => `${item.permissionCode}` !== `${code}`).map(item => {
        if (item.children && item.children.length) {
          return {
            ...item,
            children: this.filterMenuByPermissionCode(item.children, code)
          }
        }
        return item
      })
    }
  }
}
</script>

<style lang="less" scoped>
.aside-box {
  max-width: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: #fff;
}
</style>
<style lang="less" scoped>
@import "../assets/less/color.less";
aside {
  border-right: solid 1px #e6e6e6;
  .el-menu {
    height: 100%;
    // overflow: auto;
    border-right: 0;
    &.collapse {
      overflow: hidden;
    }
    .iconfont {
      display: inline-block;
      max-width: 16px;
    }
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
  }
  .el-menu-channel:not(.el-menu--collapse) {
    width: 200px;
    min-width: 200px;
  }
  .channel-title {
    padding: 10px 20px 6px;
    font-size: 12px;
    color: #999999;
  }
  .el-submenu {
    .el-menu-item {
      min-width: 180px;
      overflow: hidden;
      height: 37px;
      line-height: 35px;
      margin-left: 8px - 3px;
      padding-right: 0;
      display: inline-block;
      text-overflow: ellipsis;
      width: 95%;
    }
  }
  .el-menu-item,
  .el-submenu__title {
    height: 45px;
    line-height: 45px;
    span {
      margin-left: 8px;
      font-size: 14px;
    }
  }
  .el-loading-spinner {
    width: 200px;
    top: 10%;
  }
  .el-menu-item {
    font-size: 13px;
    display: flex;
    align-items: center;
  }
  .menu-template {
    position: relative;
    & + .menu-template::before {
      content: "";
      position: absolute;
      width: 90%;
      margin-left: 10%;
      height: 1px;
      background-color: #ebeef5;
      transform: scaleY(0.7);
    }
  }
  .single-menu {
    height: 47px !important;
    .iconfont {
      color: #909399;
      margin-top:1px;
      height: 100%;
    }
    span {
      margin-top: 1px;
      display: inline-block;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SideBar.vue